import {mapGetters, mapActions} from 'vuex';
import moment from 'moment';

// constants
import * as FCFS from '@/store/constants/fcfs';

// mixins
import AuthUser from '@/mixins/authenticated-user';

// components
import SearchPatientAutoComplete from '@/views/Common/Patient/SearchPatientAutoComplete';
import SearchDoctorAutoComplete from '@/views/Common/Doctor/SearchDoctorAutoComplete';

export default {
  props: {
    modalShow: {
      type: Boolean,
      default: false
    }
  },
  components: {
    SearchPatientAutoComplete,
    SearchDoctorAutoComplete
  },
  mixins: [AuthUser],
  computed: {
    ...mapGetters({
      lastQueue: FCFS.GET_LAST_QUEUE
    }),

    canSave() {
      console.log(this.queue);
      // debugger
      return (this.queue.patient_id && this.queue.priority > 0);
    }
  },
  data() {
    return {
      queue: {},
      patients: [],
      reset: false,
      isProcessing: false
    };
  },
  methods: {
    ...mapActions({
      saveQueue: FCFS.ACTION_ADD_QUEUE,
      getLastQueue: FCFS.ACTION_GET_LAST_QUEUE
    }),

    /**
     * Get the last queue for a given doctor.
     *
     * @param doctorId
     * @returns {Promise<void>}
     */
    async handleGetLastQueue(doctorId) {
      await this.getLastQueue(doctorId);
      this.setLastPriority(this.lastQueue.priority || 1);
    },

    /**
     * Set the last priority
     *
     * @param priority
     */
    setLastPriority(priority) {
      this.queue = {...this.queue, ...{priority: (priority) ? priority + 1 : 1}};
    },

    /**
     *  Handle the selected patient.
     *
     * @param {Object} item
     */
    selectedPatient(item) {
      if (item) {
        this.queue = {
          ...this.queue, ...{
            patient_id: item.key,
            patient_first_name: item.first_name,
            patient_last_name: item.last_name
          }
        }
      } else {
        this.queue = {...this.queue, ...{priority: this.queue.priority}};
      }
    },

    /**
     * Handle doctor selection
     *
     * @param item
     */
    selectedDoctor(item) {
      if (item) {
        this.queue.doctor_id = item.key;
        this.handleGetLastQueue(item.key);
      } else {
        this.queue.doctor_id = null;
        this.queue.priority = null;
      }

      this.queue = {...this.queue};
    },

    /**
     * Save information.
     */
    save() {
      this.queue.appointment_date = moment().format('Y-MM-DD');
      this.queue.status = 'awaiting';
      this.isProcessing = true;

      this.saveQueue(this.queue).then(() => {
        this.hide();
        this.clear();
        this.$emit('saved', true);
        this.isProcessing = false;
      }).catch(err => {
        this.isProcessing = false;
        console.log(err, 'error on saving queue');
      })
    },

    clear() {
      this.queue.notes = null;
      this.queue.patient_id = null;
      this.queue = {...this.queue};
      this.selectedPatient(null);
      this.reset = true;
    },

    /**
     * Hide Modal
     */
    hide() {
      this.$refs['addToQueueModal'].hide();
    },

    /**
     * Cancel Action
     */
    cancel() {
      this.clear();
      this.hide();
    },

    setDoctorData() {
      console.log(this.isDoctor, 'this.isDoctor)');
      if (this.isDoctor) {
        const doctorId = this.authUser.doctor.id;
        this.handleGetLastQueue(doctorId);
        this.queue = {...this.queue, ...{doctor_id: doctorId}};
      }
    }
  },

  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent) => {
      if (bvEvent.componentId === 'addToQueueModal') {
        this.setDoctorData();
      }
    })
  },
}



// WEBPACK FOOTER //
// ./src/views/FCFS/Modal/queue-form-modal.js